// @ts-nocheck
import type { Requests } from '../../../../base/realtime-session';
import type { SystemsIntegrationsGet } from '../../../../types/server/modules/systemsIntegrations/get';

export type * from '../../../../types/server/modules/systemsIntegrations/get';

export const createGet = ( requests: Requests ): SystemsIntegrationsGet => ({
  systems_integrations_webhooks_get: ( params,headers ) => {
      return requests.get( `/systems-integrations/:connectorId/:route`, params, headers );
    },
  channel_import_preview_query: ( params,headers ) => {
      return requests.get( `/channel-import-preview/:previewId`, params, headers );
    },
  erp_container_import_warehouse_discovery: ( params,headers ) => {
      return requests.get( `/erp-container-import/:integrationId/warehouse-discovery`, params, headers );
    },
  erp_container_import_price_list_discovery: ( params,headers ) => {
      return requests.get( `/erp-container-import/:integrationId/price-list-discovery`, params, headers );
    },
  erp_stock_import_projection: ( params,headers ) => {
      return requests.get( `/erp-stock-import/:integrationId/stock-import-projection`, params, headers );
    },
  erp_price_import_projection: ( params,headers ) => {
      return requests.get( `/erp-price-import/:integrationId/price-import-projection`, params, headers );
    }
});
